<script>
    import PreviewComponent from "./PreviewComponent";
    import PaymentMessagesComponent from "../../components/pagesbuilder/dynamic-components/PaymentMessagesComponent";
    
    export default {
        name: "PreviewPaymentMessagesComponent",
        
        computed: {
            message() {
                if (this.product.type === 'subscription') {
                    return `
                        Unfortunately, you cannot buy this product. 
                        You can only have access to one subscription per time. 
                        Please cancel your current subscription and try again.
                    `;
                }

                return `
                    Unfortunately, you cannot buy this product. 
                    It seems that you've already purchased it, or does not exist anymore.
                `;
            }
        },
        
        mixins: [
            PreviewComponent,
            PaymentMessagesComponent
        ]
    }
</script>
